/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Card,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import NewContact from './NewContact';
import ContactList from './ContactList';
import companyServices from '../../../../redux/services/companyServices';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
    padding: '30px 20px 30px 20px',
  },
}));

const PedagogicData = ({ company }) => {
  const [pedagogicData, setPedagogicData] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    companyServices.getCompanyDataById(company._id)
      .then((res) => {
        setPedagogicData(res.pedagogicData);
        // setLoading(false);
      });
  }, []);

  return (
    <Card className={classes.root}>
      <NewContact companyId={company._id} pedagogicData={pedagogicData} setPedagogicData={setPedagogicData} />
      <ContactList companyId={company._id} pedagogicData={pedagogicData} setPedagogicData={setPedagogicData} />
    </Card>
  );
};

PedagogicData.propTypes = {
  company: PropTypes.object.isRequired,
};

function mapState(state) {
  const { company } = state.company;
  return { company };
}

const connectedPedagogicData = connect(mapState, null)(PedagogicData);

export default withRouter(connectedPedagogicData);
